module.exports = __webpack_public_path__ + "img/9.12f58c3c.png";